module.exports = __webpack_public_path__ + "static/media/logo-wedding@3x.13b6007f.png";